/**
 * @fileoverview Client component exports for the RAG chatbot system
 * @module client/components
 *
 * This module provides customer-facing chatbot components for embedding
 * into applications and websites.
 */

// Chatbot Demo Component
export { default as ChatbotDemo } from "./chatbot-demo";

// Chat Widget Components
export { default as ChatbotWidget } from "./chatbot-widget";
export { default as ChatDock } from "./chat-dock";
export { default as FloatingChatButton } from "./floating-chat-button";

// RAG Chat Component

// UI Components
export { default as SuggestedQuestions } from "./suggested-questions";

// Internationalization
export { I18nProvider, useI18n } from "./i18n-context";

// Configuration exports
export * from "./i18n-config";
export * from "./theme-config";
export * from "./suggested-questions-config";
